import lazyLoadOnRender from '../../lazy/loadOnRender';

const ErrorRefreshMessageBar = () =>
  import(/* webpackChunkName: "4-feat-errorrefreshmessagebar" */ './ErrorRefreshMessageBar');

export default lazyLoadOnRender({ loader: ErrorRefreshMessageBar });
